import { memo } from 'react'

export const SpreadsheetTableCorner = memo(() => (
  <th className="shr-relative before:shr-absolute before:shr-bottom-[calc(theme(spacing[0.25])_/_2)] before:shr-right-[calc(theme(spacing[0.25])_/_2)] before:shr-block before:shr-h-[calc(1em_*_theme(lineHeight.normal))] before:shr-w-[calc(1em_*_theme(lineHeight.normal))] before:shr-bg-action-background before:shr-p-[calc(theme(spacing[0.25])_/_2)] before:shr-content-[''] before:[clip-path:polygon(0_100%,_100%_0,_100%_100%)]" />
))
